export const overViewItems: {
  title: string
  descriptions: Array<string | {  post: string; name: string; url?: string}>;
  url?: string
}[] = [
  {
    title: '商号',
    descriptions: [
      '株式会社トライアルホールディングス （TRIAL Holdings, Inc.）',
    ],
  },
  {
    title: '設立',
    descriptions: ['2015年9月'],
  },
  {
    title: '資本金',
    descriptions: ['202億3,741万8,600円（2026年6月30日現在）'],
  },
  {
    title: '所在地',
    descriptions: [
      '本社',
      '〒813-0034 福岡市東区多の津1丁目12番2号',
      '',
      '東京オフィス',
      '〒108-0023 東京都港区芝浦三丁目16番16号 住友不動産田町ビル東館 5F（総合受付）',
      '',
      { post: 'Acces', name: 'アクセス', url: '/company/access/'}
  ],
  },
  {
    title: '事業内容',
    descriptions: [
      '小売、物流、金融・決済、リテールテックなど、各事業を中心とした企業グループの企画・管理・運営（純粋持株会社）。',
    ],
  },
  {
    title: '会長',
    descriptions: [
      '永田 久男',
    ],
  },
  {
    title: '役員',
    descriptions: [
      {post:'代表取締役社長',name:'永田 洋幸'},
      {post:'取締役',name:'石橋 亮太'},
      {post:'社外取締役',name:'立本 博文'},
      {post:'社外取締役',name:'張 相秀'},
      {post:'常勤監査役',name:'上里 剛志'},
      {post:'社外監査役',name:'橋本 道成'},
      {post:'社外監査役',name:'薄鍋 大輔'}
    ],
  },
  {
    title: '従業員数（グループ連結）',
    descriptions: ['社員 9,434名（2026年6月30日現在）'],
  },
  {
    title: 'グループ会社',
    descriptions: [
      '株式会社トライアルホールディングス（持株会社）',
      '株式会社トライアルカンパニー',
      '株式会社トライアルストアーズ',
      '株式会社トライアルGO',
      '株式会社魚寅',
      '株式会社西友',
      '株式会社西友プロキュアメント',
      '株式会社西友サービス',
      '株式会社トライアルスーパーセンター',
      '株式会社RIALT',
      '株式会社明治屋',
      '株式会社こはく本舗',
      '株式会社トライアルフードパーク',
      '株式会社MLS',
      '株式会社SU-PAY',
      '株式会社トライアルカーズ',
      '株式会社トライアル・インシュアランス・サービス',
      'TRIAL.Korea Co.,Ltd.（関連会社）',
      'F&G Retail Co.,Ltd.（関連会社）',
      '株式会社トライアルテクノロジー',
      '株式会社Retail AI',
      '拓锐安（上海）科技有限公司',
      '烟台创迹软件有限公司',
      '上海翔迹企业管理有限公司',
      '株式会社TRYU',
      '株式会社SalesPlus（関連会社）',
      '株式会社RetailｰCIX（関連会社）',
      'GALILEI Media株式会社（関連会社）',
      '株式会社トライアルリアルエステート',
      '株式会社トライアル開発',
      '株式会社河村佐藤デザイン',
      '株式会社トライアルゴルフ&リゾート',
      '株式会社ティージーアール阿蘇',
      '株式会社ティージーアール大分',
      '株式会社トライアルツアーズ',
      '株式会社トライアルヒューマンベース',
      '株式会社トライアルベネフィット',
      '株式会社トライアルチャレンジド',
      '株式会社Fieldman',
    ],
  },
  {
    title: '社名の由来',
    descriptions: [
      '当社の母体である㈱トライアルカンパニーの「トライアル（TRIAL）」は、英語で「試み」や「試練」を意味し、未来に向けて不可能へ挑戦し続ける意思を表しております。',
      '',
      'また、「カンパニー（COMPANY）」には、会社という意味の他に「仲間」という意味があります。困難に屈することなく、「挑戦し続ける仲間たち」、という意味が「トライアルカンパニー」という社名に込められています。',
      '',
      '「ITで流通を変える」という強い思いを持って、ITを祖業とした創業から約40年。失敗も糧にしながら、流通小売業界のムダ・ムラ・ムリを解消する挑戦を続けています。トライする仲間がいる会社、それがトライアルカンパニーです。',
      '',
      '※2015年９月に、㈱トライアルホールディングスを純粋持株会社として設立し、㈱トライアルカンパニーを中核とする当社グループ会社の株式を保有する持株会社体制に移行しました。',
    ],
  },
]

export const revenue = {
  title: '売上高（連結）',
  descriptions: ['1兆3,471億円（2026年6月期）'],
}

export const shops = {
  title: '店舗数',
  descriptions: [
    '合計：621店舗',
    '・トライアル：378店舗',
    '・ 西友：243店舗',
    '（2026年6月30日現在）',
  ],
  src: '/images/TRIAL_sales_shops_figure2026_JP.png',
}
